export default [
  {
    type: 'function',
    name: 'createSmartWallet',
    inputs: [
      {
        name: 'encodedOwners',
        type: 'bytes[]',
        internalType: 'bytes[]',
      },
      {
        name: 'nonce',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'getAddress',
    inputs: [
      {
        name: 'encodedOwners',
        type: 'bytes[]',
        internalType: 'bytes[]',
      },
      {
        name: 'nonce',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'address',
        internalType: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getKeyNonce',
    inputs: [
      {
        name: 'smartWallet',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'key',
        type: 'uint192',
        internalType: 'uint192',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getNonce',
    inputs: [
      {
        name: 'smartWallet',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [
      {
        name: '',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    stateMutability: 'view',
  },

  {
    type: 'function',
    name: 'smartWalletFactory',
    inputs: [],
    outputs: [
      {
        name: '',
        type: 'address',
        internalType: 'contract ISmartWalletFactory',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'event',
    name: 'ZoraSmartWalletCreated',
    inputs: [
      {
        name: 'smartWallet',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'baseOwner',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'owners',
        type: 'address[]',
        indexed: false,
        internalType: 'address[]',
      },
      {
        name: 'nonce',
        type: 'uint256',
        indexed: false,
        internalType: 'uint256',
      },
    ],
    anonymous: false,
  },
] as const
